// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2BOPL","comment":"styles_comment__2sl0S"};